export const PAYMENTS_LABEL = 'Пополнение кассы';
export const COLLECTION_LABEL = 'Добавить инкассацию';
export const EXPENSES_LABEL = 'Добавить расход';
